// Helpers
import { findSimilarInObjectCollection } from "@/Common/helpers/Arrays";

const getWildcardModels = (models = [], useRegexModels = false) => {
	if (!models.length || !useRegexModels) {
		return models;
	}

	const addModels = findSimilarInObjectCollection(models, "model");
	return [...models, ...addModels];
};

export { getWildcardModels };
